import { useState, useEffect } from 'react';

export const useIsAdBlocked = () => {
  const [isAdBlocked, setIsAdBlocked] = useState(false);

  useEffect(() => {
    const detectAdBlocking = async () => {
      try {
        const response = await fetch('https://app.posthog.com/static/array.js');

        if (!response.ok) {
          setIsAdBlocked(true);
          return;
        }

        if (typeof window !== 'undefined') {
          setTimeout(() => {
            const posthogInstance = (window as any).posthog;

            if (!posthogInstance || !posthogInstance.capture) {
              setIsAdBlocked(true);
            }
          }, 1000);
        }
      } catch (error) {
        setIsAdBlocked(true);
      }
    };

    detectAdBlocking();
  }, []);

  return isAdBlocked;
};
